//
//
//
//
//
//


import moment from "moment";

export default {
  name: "ScheduleTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {},
  data: () => ({
    separator: "horizontal",
    pagination: {
      rowsPerPage: 10
    },
    columns: [
      {
        name: "day",
        required: false,
        label: "Dia da semana",
        align: "left",
        field: row => row.weekday,
        format: (val) => (moment(val, 'd').format('dddd')),
        sortable: false
      },
      {
        name: "opening-hours",
        required: false,
        label: "Abertura",
        align: "left",
        field: row => row.opening_hour,
        format: row => (row ? (moment(row.opening_hour).format('HH:mm')) : "N/A"),
        sortable: false
      },
      {
        name: "closing-hours",
        required: false,
        align: "left",
        label: "Encerramento",
        field: row => row.closing_hour,
        format: row => (row ? (moment(row.closing_hour).format('HH:mm')) : "N/A"),
        sortable: false
      }
    ]
  })
};
